export default {
  'required': '必填',
  'last': '至少上传一个',
  'noData': '暂无数据',

  'search': '搜  索',
  'returnsApplication': '热词搜索',
  'clearCondition': '清除条件',
  'more': '更多',
  'singleChoice': '单选',
  'multipleChoice': '多选',
  'allLook': '全部可见',
  'allLook2': '全部可见（仅限上传10个）',
  'onlyLook': '仅客户池可见',
  'onlyLook2': '仅客户池可见',
  'onlyPreRegistered': '仅预登记客商可见',
  'onlyPreRegistered2': '仅预登记客商可见',
  'invitation': '发送邀请函',
  'Handbook': '帮助手册',
  'versionLog': '更新日志',
  'all': '全部',
  'toBeConfirmed': '待确认',
  'confirmedText': '已确认',
  'toBeConfirmedPerson': '待员工确认',
  'productTipsContent':'需展商授权后才能查看，请点”邀约“，展商将根据您的信息进行确认。',
  'productTipsTitle':'提示',
  'ok':'确定',
  'utilsTips': '注意：1、此处上传的是一个产品的图片，可上传该产品不同角度、不同颜色的图片',
  'utilsTips2': '2、第一张图将作为展品封面图，展示在展品列表上，请注意上传完整的图片',
  'success': '操作成功',
  'exhibitorResearch': '展商调研',
  'registrationLook': '预登记客商可见'
}
